import {
  Arrow as PopoverPrimitiveArrow,
  Content as PopoverPrimitiveContent,
} from '@radix-ui/react-popover';
import styled from 'styled-components';

import {
  borderRadius,
  boxShadows,
  colors,
  spacing,
  zIndexes,
} from '../../theme';
import IconButton from '../IconButton/IconButton';

export const PopoverContentCard = styled(PopoverPrimitiveContent)`
  z-index: ${zIndexes.modal};
  box-sizing: border-box;
  padding: ${spacing['4x']};
  background: ${colors.white};
  border-radius: ${borderRadius['3x']};
  max-width: 90vw;
  box-shadow: ${boxShadows.elevation4};
`;

export const PopoverArrow = styled(PopoverPrimitiveArrow)`
  fill: ${colors.white};
`;

PopoverArrow.displayName = 'PopoverArrow';

export const PopoverCloseButton = styled(IconButton)`
  position: absolute;
  top: ${spacing['4x']};
  right: ${spacing['4x']};
`;
